<h3-button-with-popover
  popoverTitle="Enhanced Point Cloud"
  [tooltipText]="tooltip"
>
  <ng-container projection-location="button">
    <mat-icon [h3CustomIcon]="enhancedPointCloudIcon"></mat-icon>
  </ng-container>
  <h3-enhanced-point-cloud-settings
    projection-location="popover-content"
  ></h3-enhanced-point-cloud-settings>
</h3-button-with-popover>
